<template>
  <component :is="linkElement" :href="externalLink" :to="link" class="text-decoration-none">
    <div class="round-button text-muted justify-content-center">
      <div class="bg-white rounded-circle square d-flex mx-auto my-1">
        <img :src="image" :alt="title" width="48px" height="48px" class="m-auto">
      </div>
      <div class="mt-3">{{title}}</div>
      <div v-if="subtitle" class="subtitle-text small">{{subtitle}}</div>
    </div>
  </component>
</template>

<script>

  export default {
    props: {
      link: {
        type: String
      },
      externalLink: {
        type: String
      },
      image: {
        required: true
      },
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String
      }
    },

    computed: {
      linkElement() {
        if (this.externalLink) {
          return 'a'
        }
        if (this.link) {
          return 'router-link'
        }
        return 'div'
      }
    }
  }

</script>

<style lang="scss">
.square {
    height: 6rem;
    width: 6rem;
    border: 1px solid #E4E9F5;
}
.rounded-circle:hover {
  transition: 0.5s;
  border: 1px solid white;
  box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.1);
}
.subtitle-text {
  letter-spacing: -0.05em;
  line-height: 0.9em;
}
</style>
